import { useCFPValues } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { Box, Button, ComposableTypography } from '@bcp-nextgen-dx-component-factory/design-system';
import { AppLayout, CloseCircle, logos } from '@components';
import { AppHelper } from '@helpers';
import { useTranslation } from '@hooks';
import { useSearchParamsStore } from '@store';

const PRIMARY_DARK_COLOR_TOKEN = 'primary-dark';

const resources = {
	title: 'general.genericError.title',
	subtitle: 'general.genericError.subtitle',
	button: 'general.back',
};

export const ErrorScreen = () => {
	const { t } = useTranslation();
	const { getSpacing, getToken } = useCFPValues();
	const { redirectUri, state } = useSearchParamsStore();

	return (
		<AppLayout
			styles={{
				background: 'linear-gradient(135deg, #d1005d -0.21%, #e3669e 99.79%)',
				justifyContent: 'center',
				padding: getSpacing({
					default: {
						default: [40, 24],
						mobile: [40, 24],
						tablet: [40, 24],
						laptop: [120, 150],
					},
				}),
				gap: getSpacing({ default: { default: 96 } }),
			}}
		>
			<Box styles={{ position: 'absolute', top: getSpacing({ default: { default: 120 } }) }}>
				<logos.MbcpWhiteLogo width={160} height={48} />
			</Box>

			<Box styles={{ flexDirection: 'column' }}>
				<CloseCircle width={72} height={72} fill="#fff" />

				<ComposableTypography
					baseProps={{
						appearance: getToken({
							default: {
								default: 'headline-100-05',
							},
						}),
						colorToken: PRIMARY_DARK_COLOR_TOKEN,
						styles: {
							marginTop: getSpacing({ default: { default: 24 } }),
							maxWidth: getSpacing({ default: { default: 848 } }),
						},
					}}
					text={t(resources.title)}
					tags={{
						b: {
							appearance: getToken({
								default: {
									default: 'headline-100-03',
								},
							}),
							colorToken: PRIMARY_DARK_COLOR_TOKEN,
						},
					}}
				/>

				<ComposableTypography
					baseProps={{
						appearance: getToken({
							default: { default: 'subtitle-100-02' },
						}),
						colorToken: PRIMARY_DARK_COLOR_TOKEN,
						styles: {
							marginTop: getSpacing({ default: { default: 8 } }),
						},
					}}
					text={t(resources.subtitle)}
					tags={{}}
				/>

				{redirectUri && (
					<Box styles={{ alignSelf: 'start', marginTop: getSpacing({ default: { default: 32 } }) }}>
						<Button
							size="small"
							surface="onInverse"
							variant="secondary"
							onPress={() => {
								AppHelper.exit(redirectUri, 'error', state);
							}}
						>
							{t(resources.button)}
						</Button>
					</Box>
				)}
			</Box>
		</AppLayout>
	);
};
